import $ from 'jquery';
import jQueryPlaceholer from 'jquery-placeholder';
import Backbone from 'backbone';
import Global from 'models/Global';
import Handlebars from 'handlebars';
import template from 'hbars!templates/privateCommunity';
import 'hbars!templates/join';

var PrivateCommunityView = Backbone.View.extend({
    className: 'auth-view-box-private-community',

    events: {
        'click .auth-view-box-access-code-button': 'accessCodeClicked',
        'click .auth-view-box-enter-code-request-button': 'requestClicked',
        'keydown input': 'inputKeyDown'
    },

    initialize: function(options) {
        options = options || {};
        this.model = this.model || Global.get('me');
        this.event = options.event || Global.get('event');
        this.listenTo(this.model, 'change:isLoading', this.setLoading);
        this.listenTo(this.model, 'authorize-success', this.accessCodeSuccess);
        this.listenTo(this.model, 'authorize-error', this.accessCodeError);
        this.listenTo(this.model, 'change:requestPendingApproval', this.pendingApprovalChanged);
    },

    inputKeyDown: function(e) {
        var ev = e || event;
        if (ev.keyCode == 13) {
            this.accessCodeClicked();
        }
    },

    accessCodeSuccess: function() {
        this.joinEvent();
    },

    accessCodeError: function(errorCode) {
        this.$('.auth-view-box-guide-access-code').hide();
        this.$('.auth-view-box-guide-request-pending').hide();
        if (this.model.get('requestPendingApproval')) {
            this.$('.auth-view-box-guide-can-request').hide();
            this.$('.auth-view-box-pending-approval').fadeIn('slow');
        }
        this.showError();
    },

    showError() {
        this.$('.auth-view-box-guide-wrong-code').fadeIn('slow');
    },
    hideError() {
        this.$('.auth-view-box-guide-wrong-code').hide();
    },

    accessCodeClicked: function() {
        var accessCode = this.$('input').val();
        this.model.authorize(this.event.id, accessCode);
    },

    requestClicked: function() {
        var thisView = this;
        this.model.requestAuthorize(this.event.id, {
            success: function() {
                thisView.requestMade = true;
                thisView.$('.auth-view-box-enter-code-form').hide();
            }
        });
    },

    joinEvent: function() {
        this.model.join(this.event.id);
    },

    pendingApprovalChanged: function() {
        if (this.model.get('requestPendingApproval')) {
            this.$('.auth-view-box-guide-access-code').hide();
            this.hideError();
            this.$('.auth-view-box-enter-code-request').hide();
            this.$('.auth-view-box-guide-request-pending').fadeIn('slow');
            if (this.requestMade) {
                this.$('.auth-view-box-pending-approval').fadeIn('slow');
            }
        }
    },

    setLoading: function() {
        var loading = this.model.get('isLoading');
        this.$('.loading').toggleClass('hide', !loading);
    },

    render: function() {
        var html = template({
            me: this.model.toJSON(),
            event: this.event.toJSON()
        });
        this.$el.html(html);
        this.$('input[placeholder], textarea[placeholder]').placeholder();
        return this;
    }

});

export default PrivateCommunityView;


